import { getAccessToken } from './tokenStorage'

/** The marker is UI state only. It must never be sent as a Bearer credential. */
export const BROWSER_SESSION_MARKER = 'cookie-session'

export function browserAuthHeaders(token = getAccessToken()): Record<string, string> {
  const headers: Record<string, string> = { 'X-Auth-Transport': 'cookie' }
  if (token && token !== BROWSER_SESSION_MARKER) headers.Authorization = `Bearer ${token}`
  const match = typeof document !== 'undefined' ? document.cookie.match(/(?:^|;\s*)POS_CSRF=([^;]*)/) : null
  if (match) headers['X-POS-CSRF'] = decodeURIComponent(match[1])
  return headers
}
